import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22styles.js%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../../public/next-assets/fonts/fonts_Ultramarine_WOFF_Ultramarine-Regular.woff2%22,%22weight%22:%22400%22},{%22path%22:%22../../../public/next-assets/fonts/fonts_Ultramarine_WOFF_Ultramarine-Medium.woff2%22,%22weight%22:%22500%22},{%22path%22:%22../../../public/next-assets/fonts/fonts_Ultramarine_WOFF_Ultramarine-Bold.woff2%22,%22weight%22:%22700%22}],%22style%22:%22normal%22,%22preload%22:true,%22variable%22:%22--font-ultramarine%22,%22display%22:%22swap%22,%22adjustFontFallback%22:%22Arial%22}],%22variableName%22:%22ultramarine%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'ultramarine', 'ultramarine Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
